export const getStringChangeHandler =
  (key, handler) =>
  ({target: {value}}) =>
    handler({[key]: value.trimStart()});

export const getIntegerChangeHandler =
  (key, handler) =>
  ({target: {value}}) =>
    handler({[key]: value !== '' ? parseInt(value) : undefined});
